import { render, staticRenderFns } from "./revealKgWorkspace.vue?vue&type=template&id=02cc952c"
import script from "./revealKgWorkspace.vue?vue&type=script&lang=js"
export * from "./revealKgWorkspace.vue?vue&type=script&lang=js"
import style0 from "./revealKgWorkspace.vue?vue&type=style&index=0&id=02cc952c&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02cc952c')) {
      api.createRecord('02cc952c', component.options)
    } else {
      api.reload('02cc952c', component.options)
    }
    module.hot.accept("./revealKgWorkspace.vue?vue&type=template&id=02cc952c", function () {
      api.rerender('02cc952c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace.vue"
export default component.exports